export default __webpack_public_path__ + "static/media/Jin-RightWaterSplash.cdc87399.png";